import React from 'react';
import { useOutletContext } from 'react-router-dom';

import { formatDateForDisplay } from '../../../helpers/date-time';
import Lozenge from '../../../component-library/lozenge';

const Methods = () => {
	const { data, uiGeneralConfig, uiMenuConfig } = useOutletContext();

	return (
		<>
			<h3>
				{uiMenuConfig?.methods?.label || 'Methods'}
			</h3>
			<table className="table is-bordered">
				<thead>
					<tr>
						{uiGeneralConfig?.methodBehaviour?.enabled !== false && (
							<th>{uiGeneralConfig?.methodBehaviour?.label || 'Behaviour'}</th>
						)}
						<th>Name</th>
						<th>Description</th>
						<th>URI</th>
						<th>Last Updated</th>
					</tr>
				</thead>
				<tbody>
					{data?.operations.length ? (
						data?.operations.map((item, index) => (
							// eslint-disable-next-line react/no-array-index-key
							<tr key={index}>
								{uiGeneralConfig?.methodBehaviour?.enabled !== false && (
									<td>
										<Lozenge
											label={item.operationBehaviour}
										/>
									</td>
								)}
								<td>{item.name}</td>
								<td className="truncated" title={item.description}>{item.description}</td>
								<td>{item.uri}</td>
								<td>{formatDateForDisplay(item.dateUpdated)}</td>
							</tr>
						))
					) : (
						<tr>
							<td colSpan={uiGeneralConfig?.methodBehaviour?.enabled !== false ? 5 : 4} className="grey-text text-center">No methods found</td>
						</tr>
					)}
				</tbody>
			</table>
		</>
	);
};

export default Methods;
